<!-- Header.vue -->
<template>
  <div class="nebula-header-wrapper">
    <!-- 스켈레톤 UI (로딩 중에 표시) -->
    <div v-if="loading" class="nebula-header-skeleton">
      <!-- 프로모션 배너 스켈레톤 -->
      <!--      <div class="nebula-skeleton-promotion-banner" :class="{'mobile-hidden': isMobile}">-->
      <!--        <div class="nebula-container">-->
      <!--          <div class="nebula-skeleton-promotion-content"></div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- 로고 및 유틸리티 스켈레톤 -->
      <div class="nebula-skeleton-top-header">
        <div class="nebula-container">
          <div class="nebula-skeleton-header-content">
            <div class="nebula-skeleton-header-left">
              <div class="nebula-skeleton-logo"></div>
              <div class="nebula-skeleton-logo"></div>
              <div class="nebula-skeleton-favorite"></div>
            </div>
            <div class="nebula-skeleton-header-right">
              <div class="nebula-skeleton-utility-icons">
                <div class="nebula-skeleton-icon"></div>
                <div class="nebula-skeleton-icon"></div>
                <div class="nebula-skeleton-icon"></div>
              </div>
              <div class="nebula-skeleton-auth-buttons">
                <div class="nebula-skeleton-btn"></div>
                <div class="nebula-skeleton-btn"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 검색 및 메인 로고 스켈레톤 -->
      <div class="nebula-skeleton-main-header">
        <div class="nebula-container">
          <div class="nebula-skeleton-main-header-content">
            <div class="nebula-skeleton-main-logo"></div>
            <div class="nebula-skeleton-search-bar" :class="{'mobile-hidden': isMobile}"></div>
            <div class="nebula-skeleton-kakao-promo" :class="{'mobile-hidden': isMobile}"></div>
          </div>
        </div>
      </div>

      <!-- 메인 네비게이션 스켈레톤 -->
      <div class="nebula-skeleton-main-nav" :class="{'mobile-hidden': isMobile}">
        <div class="nebula-container">
          <div class="nebula-skeleton-nav-content">
            <div class="nebula-skeleton-primary-nav">
              <div v-for="i in 5" :key="`primary-nav-${i}`" class="nebula-skeleton-nav-item"></div>
            </div>
            <div class="nebula-skeleton-secondary-nav">
              <div v-for="i in 4" :key="`secondary-nav-${i}`" class="nebula-skeleton-nav-item-small"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 실제 헤더 컨텐츠 (로딩 완료 후 표시) -->
    <div v-else>
      <!-- 상단 프로모션 배너 (모바일에서는 숨김) -->
      <!--      <div class="nebula-promotion-banner" v-if="showPromoBanner && !isMobile">-->
      <!--        <div class="nebula-container">-->
      <!--          <div class="nebula-promotion-content">-->
      <!--            <img src="@/assets/user/img/noti_icon2.png" alt="로고">-->
      <!--            <span class="nebula-promotion-text">"신규 오픈 기념 쿠폰 1만원 증정합니다!</span>-->
      <!--            <img src="@/assets/user/img/noti_icon.png" alt="로고">-->
      <!--            <button class="nebula-close-btn" @click="closePromoBanner">-->
      <!--              <span>1일간 닫기</span>-->
      <!--              <i class="bi bi-x"></i>-->
      <!--            </button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- 로고 및 유틸리티 영역 -->
      <div class="nebula-top-header">
        <div class="nebula-container">
          <div class="nebula-header-content">
            <!-- 왼쪽 로고 영역 -->
            <div class="nebula-header-left" :class="{'mobile-hidden': isMobile}">
              <button class="nebula-favorite-btn" @click="toggleFavorite" :class="{ 'favorited': isFavorited }">
                <i class="bi" :class="isFavorited ? 'bi-star-fill' : 'bi-star'"></i>
                <span>{{ isFavorited ? '즐겨찾기 완료' : '닥터마켓 즐겨찾기' }}</span>
              </button>
            </div>

            <!-- 오른쪽 유틸리티 영역 -->
            <div class="nebula-header-right">
              <div class="nebula-utility-icons">
                <button class="nebula-icon-btn" onclick="location.href='/mypage'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M240.92-268.31q51-37.84 111.12-59.77Q412.15-350 480-350t127.96 21.92q60.12 21.93 111.12 59.77 37.3-41 59.11-94.92Q800-417.15 800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 62.85 21.81 116.77 21.81 53.92 59.11 94.92ZM480.01-450q-54.78 0-92.39-37.6Q350-525.21 350-579.99t37.6-92.39Q425.21-710 479.99-710t92.39 37.6Q610-634.79 610-580.01t-37.6 92.39Q534.79-450 480.01-450ZM480-100q-79.15 0-148.5-29.77t-120.65-81.08q-51.31-51.3-81.08-120.65Q100-400.85 100-480t29.77-148.5q29.77-69.35 81.08-120.65 51.3-51.31 120.65-81.08Q400.85-860 480-860t148.5 29.77q69.35 29.77 120.65 81.08 51.31 51.3 81.08 120.65Q860-559.15 860-480t-29.77 148.5q-29.77 69.35-81.08 120.65-51.3 51.31-120.65 81.08Q559.15-100 480-100Zm0-60q54.15 0 104.42-17.42 50.27-17.43 89.27-48.73-39-30.16-88.11-47Q536.46-290 480-290t-105.77 16.65q-49.31 16.66-87.92 47.2 39 31.3 89.27 48.73Q425.85-160 480-160Zm0-350q29.85 0 49.92-20.08Q550-550.15 550-580t-20.08-49.92Q509.85-650 480-650t-49.92 20.08Q410-609.85 410-580t20.08 49.92Q450.15-510 480-510Zm0-70Zm0 355Z"/></svg>
                </button>
                <button class="nebula-icon-btn nebula-icon-notification" onclick="location.href='/cart'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M286.15-97.69q-29.15 0-49.57-20.43-20.42-20.42-20.42-49.57 0-29.16 20.42-49.58 20.42-20.42 49.57-20.42 29.16 0 49.58 20.42 20.42 20.42 20.42 49.58 0 29.15-20.42 49.57-20.42 20.43-49.58 20.43Zm387.7 0q-29.16 0-49.58-20.43-20.42-20.42-20.42-49.57 0-29.16 20.42-49.58 20.42-20.42 49.58-20.42 29.15 0 49.57 20.42t20.42 49.58q0 29.15-20.42 49.57Q703-97.69 673.85-97.69ZM240.61-730 342-517.69h272.69q3.46 0 6.16-1.73 2.69-1.73 4.61-4.81l107.31-195q2.31-4.23.38-7.5-1.92-3.27-6.54-3.27h-486Zm-28.76-60h555.38q24.54 0 37.11 20.89 12.58 20.88 1.2 42.65L677.38-494.31q-9.84 17.31-26.03 26.96-16.2 9.66-35.5 9.66H324l-46.31 84.61q-3.08 4.62-.19 10 2.88 5.39 8.65 5.39h427.7q12.76 0 21.38 8.61 8.61 8.62 8.61 21.39 0 12.77-8.61 21.38-8.62 8.62-21.38 8.62h-427.7q-40 0-60.11-34.5-20.12-34.5-1.42-68.89l57.07-102.61L136.16-810H90q-12.77 0-21.38-8.62Q60-827.23 60-840t8.62-21.38Q77.23-870 90-870h61.15q10.24 0 19.08 5.42 8.85 5.43 13.46 15.27L211.85-790ZM342-517.69h280-280Z"/></svg>
                  <span class="nebula-badge">{{ cartItemCount }}</span>
                </button>
                <button class="nebula-icon-btn nebula-icon-cart" onclick="location.href='/mypage/notification-settings'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M210-204.62q-12.75 0-21.37-8.62-8.63-8.63-8.63-21.39 0-12.75 8.63-21.37 8.62-8.61 21.37-8.61h42.31v-298.47q0-80.69 49.81-142.69 49.8-62 127.88-79.31V-810q0-20.83 14.57-35.42Q459.14-860 479.95-860q20.82 0 35.43 14.58Q530-830.83 530-810v24.92q78.08 17.31 127.88 79.31 49.81 62 49.81 142.69v298.47H750q12.75 0 21.37 8.62 8.63 8.63 8.63 21.39 0 12.75-8.63 21.37-8.62 8.61-21.37 8.61H210Zm270-293.07Zm-.07 405.38q-29.85 0-51.04-21.24-21.2-21.24-21.2-51.07h144.62q0 29.93-21.26 51.12-21.26 21.19-51.12 21.19Zm-167.62-172.3h335.38v-298.47q0-69.46-49.11-118.57-49.12-49.12-118.58-49.12-69.46 0-118.58 49.12-49.11 49.11-49.11 118.57v298.47Z"/></svg>
                  <span class="nebula-badge">0</span>
                </button>

                <!-- 로그인/로그아웃 버튼 -->
                <div v-if="isLoggedIn" class="auth-buttons">
                  <span class="user-name">{{ userName }}</span>
                  <button class="logout-btn" @click="handleLogout">로그아웃</button>
                </div>
                <div v-else class="auth-buttons">
                  <router-link to="/login" class="login-btn">로그인</router-link>
                  <router-link to="/signup" class="signup-btn">회원가입</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 검색 및 메인 로고 영역 -->
      <div class="nebula-main-header">
        <div class="nebula-container">
          <!-- 모바일 메뉴 버튼 -->
          <button class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
            <i class="bi bi-list"></i>
          </button>

          <div class="nebula-main-header-content">
            <!-- 메인 로고 -->
            <div class="nebula-main-logo">
              <a href="/home"> <img src="@/assets/images/newlogo.png" alt="로고"></a>
            </div>

            <!-- 검색창 (모바일에서는 숨김) -->
            <div class="nebula-search-bar" v-if="!isMobile">
              <input
                  type="text"
                  class="nebula-search-input"
                  :placeholder="searchPlaceholder"
                  v-model="searchQuery"
                  @keyup.enter="searchProducts"
                  @focus="openSearchSuggest"
                  @click="openSearchSuggest"
                  @keyup.esc="showSearchSuggest = false"
              >
              <button class="nebula-search-btn" @click="searchProducts">
                <i class="bi bi-search"></i>
              </button>
            </div>

            <!-- 모바일 검색 버튼 -->
            <button class="mobile-search-btn" @click="toggleMobileSearch" v-if="isMobile">
              <i class="bi bi-search"></i>
            </button>

            <div class="wrap" v-if="!isMobile">
              <div class="default">
                <i :class="isBeforeDeadline ? 'bi bi-truck success-icon' : 'bi bi-moon deadline-icon'"></i>
                <span>{{ isBeforeDeadline ? shippingDayTitle : shippingNightTitle }}</span>
              </div>
              <div class="hover-content">{{ isBeforeDeadline ? shippingDaySubtitle : shippingNightSubtitle }}</div>
            </div>
          </div>

          <!-- 모바일 검색창 (기본적으로 숨겨져 있음) -->
          <div class="mobile-search-container" v-if="showMobileSearch && isMobile">
            <div class="mobile-search-wrapper">
              <input
                  type="text"
                  class="mobile-search-input"
                  :placeholder="searchPlaceholder"
                  v-model="searchQuery"
                  @keyup.enter="searchProducts"
                  @focus="openSearchSuggest"
                  @click="openSearchSuggest"
              >
              <button class="mobile-search-submit" @click="searchProducts">
                <i class="bi bi-search"></i>
              </button>
              <button class="mobile-search-close" @click="toggleMobileSearch">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>

          <!-- 🔥 2026-10-15 검색창 드롭다운 — body 로 띄워서 메뉴줄에 가려지지 않게 (PC·모바일 공용) -->
          <SearchSuggestPanel
              v-if="showSearchSuggest && suggestAnchor"
              :anchor="suggestAnchor"
              :mobile="isMobile"
              :recent="recentSearches"
              :popular="popularSearches"
              :categories="suggestCategories"
              :save-off="searchSaveOff"
              :basis="popularBasis"
              :show-recent="suggestShow.recent"
              :show-popular="suggestShow.popular"
              :show-categories="suggestShow.categories"
              :popular-days="suggestPopularDays"
              @pick="pickSuggest"
              @remove="removeRecentSearch"
              @clear="clearRecentSearches"
              @toggle-save="toggleSearchSave"
              @pick-category="pickSuggestCategory"
              @close="showSearchSuggest = false"
          />
        </div>
      </div>

      <!-- 메인 네비게이션 영역 (모바일에서는 숨김) -->
      <nav class="nebula-main-nav" v-if="!isMobile" >
        <div class="nebula-container">
          <div class="nebula-nav-content">
            <!-- 주요 카테고리 네비게이션 -->
            <div class="nebula-primary-nav">
              <!-- 카테고리 드롭다운 메뉴 -->
              <div class="nebula-category-dropdown"
                   @mouseenter="showCategoryMenu = true;"
                   @mouseleave="showCategoryMenu = false">
                <a href="#" class="nebula-nav-item"
                   :class="{ 'active': showCategoryMenu }"
                   @click.prevent="toggleCategoryMenu"
                   @mouseenter="selectSubCategory(0)">
                  <i class="bi bi-list fs-5"></i>
                  <span>카테고리</span>
                </a>
                <div class="nebula-category-menu" v-if="showCategoryMenu">
                  <div class="nebula-category-left">
                    <ul class="nebula-category-list">
                      <!-- 🔥 1차 카테고리의 2차 카테고리들을 표시 -->
                      <li class="nebula-category-item"
                          v-for="(subCategory, index) in allSecondCategories"
                          :key="subCategory.id"
                          @mouseenter="selectSubCategory(index)"
                          :class="{ 'active': selectedSubCategoryIndex === index }">
                        <router-link :to="{ path: '/products', query: { category: subCategory.id.toString(), keyword: subCategory.title, sort: '인기도' } }"
                                     class="nebula-category-link"
                                     @click="closeCategoryMenu">
                          <!--                          <img :src="getSubCategoryIcon(subCategory.parentName)" alt="카테고리 아이콘" class="nebula-category-icon">-->
                          <span>{{ subCategory.title }}</span> <!-- 2차 카테고리 이름 표시 -->
                        </router-link>
                      </li>
                    </ul>
                  </div>
                  <div class="nebula-subcategory-right">
                    <div class="nebula-subcategory-list">
                      <div class="nebula-subcategory-group" v-if="selectedSubCategory">
                        <h4 class="nebula-subcategory-title">{{ selectedSubCategory.title }}</h4>

                        <!-- 🔥 3차/4차 카테고리를 그룹별로 가로 나열 -->
                        <div class="nebula-category-grid">
                          <template v-for="(item, itemIndex) in groupedItems" :key="`group-${itemIndex}`">
                            <!-- 🔥 3차 카테고리 (제목) -->
                            <div v-if="item.level === 3" class="nebula-third-category-section">
                              <div class="nebula-third-category-header">
                                <router-link :to="{ path: '/products', query: { category: item.id.toString(), keyword: item.name, sort: '인기도' } }"
                                             class="nebula-third-category-link"
                                             @click="closeCategoryMenu">
                                  <i class="bi bi-folder2-open"></i>
                                  {{ item.name }}
                                </router-link>
                              </div>

                              <!-- 🔥 해당 3차의 4차 카테고리들을 가로로 나열 -->
                              <div class="nebula-fourth-category-grid" v-if="item.children && item.children.length > 0">
                                <router-link v-for="child in item.children"
                                             :key="child.id"
                                             :to="{ path: '/products', query: { category: child.id.toString(), keyword: child.name, sort: '인기도' } }"
                                             class="nebula-fourth-category-item"
                                             @click="closeCategoryMenu">
                                  <span class="nebula-fourth-category-icon">•</span>
                                  {{ child.name }}
                                </router-link>
                              </div>
                            </div>

                            <!-- 🔥 2차 카테고리만 있는 경우 (3차가 없는 경우) -->
                            <div v-else-if="item.level === 2" class="nebula-second-only-section">
                              <router-link :to="{ path: '/products', query: { category: item.id.toString(), keyword: item.name, sort: '인기도' } }"
                                           class="nebula-second-only-link"
                                           @click="closeCategoryMenu">
                                <i class="bi bi-tag"></i>
                                {{ item.name }}
                              </router-link>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <a href="/products?category=2&sort=인기도&page=1" class="nebula-nav-item" @mouseenter="showCategoryMenu = true; selectSubCategory(0)" @mouseleave="showCategoryMenu = false">
                <!-- <img src="@/assets/user/img/free-icon-medicine-9260582.png"> -->
                <span>의약품</span>
              </a>
              <a href="/products?category=11&sort=인기도&page=1" class="nebula-nav-item" @mouseenter="showCategoryMenu = true; selectSubCategory(1)" @mouseleave="showCategoryMenu = false">
                <!-- <img src="@/assets/user/img/free-icon-pills-6146539.png"> -->
                <span>의료소모품</span>
              </a>
              <a href="/products?category=12&sort=인기도&page=1" class="nebula-nav-item" @mouseenter="showCategoryMenu = true; selectSubCategory(2)" @mouseleave="showCategoryMenu = false">
                <!-- <img src="@/assets/user/img/free-icon-diabetic-test-14681274.png"> -->
                <span>의료기기</span>
              </a>
              <a href="/products?category=56&sort=인기도&page=1" class="nebula-nav-item" @mouseenter="showCategoryMenu = true; selectSubCategory(3)" @mouseleave="showCategoryMenu = false">
                <!-- <img src="@/assets/user/img/free-icon-medicines-706169.png"> -->
                <span>기획전</span>
              </a>
              <!--              <a href="/products?category=12&sort=가격" class="nebula-nav-item">-->
              <!--                <img src="@/assets/user/img/free-icon-medicines-706169.png">-->
              <!--                <span>의료기기</span>-->
              <!--              </a>-->
              <!--              <a href="/points-zone" class="nebula-nav-item">-->
              <!--                <img src="@/assets/user/img/free-icon-pay-point-825512.png">-->
              <!--                <span>포인트존</span>-->
              <!--              </a>-->
            </div>

            <!-- 보조 네비게이션 -->
            <div class="nebula-secondary-nav" style="display: none">
              <a href="/mypage/coupons" class="nebula-secondary-nav-item">
                <img src="@/assets/user/img/free-icon-syringe-1021573.png">
                <span>쿠폰다운</span>
              </a>
              <a href="/mypage/reorder/default" class="nebula-secondary-nav-item">
                <img src="@/assets/user/img/free-icon-giftbox-8762962.png">
                <span>주문이력</span>
              </a>
              <!--              <a href="/new-products" class="nebula-secondary-nav-item">-->
              <!--                <img src="@/assets/user/img/free-icon-syringe-1021573.png">-->
              <!--                <span>신상품</span>-->
              <!--              </a>-->
              <!--              <a href="/promotions" class="nebula-secondary-nav-item">-->
              <!--                <img src="@/assets/user/img/free-icon-giftbox-8762962.png">-->
              <!--                <span>기획전</span>-->
              <!--              </a>-->
              <a href="/mypage/faq" class="nebula-secondary-nav-item">
                <img src="@/assets/user/img/free-icon-customer-review-9821148.png">
                <span>고객센터</span>
              </a>
              <!--              <div class="nebula-more-menu">-->
              <!--                <i class="bi bi-three-dots"></i>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </nav>

      <div class="mobile-fullscreen-menu" :class="{ 'active': showMobileMenu }">
        <div class="mobile-menu-header">
          <h3>카테고리</h3>
          <button class="mobile-menu-close" @click="toggleMobileMenu">
            <i class="bi bi-x"></i>
          </button>
        </div>

        <!-- 🔥 새로운 아코디언 스타일 모바일 메뉴 -->
        <div class="mobile-accordion-menu">
          <!-- 🔥 로딩 중일 때 스켈레톤 -->
          <div v-if="categories.length === 0" class="mobile-category-loading">
            <div v-for="i in 3" :key="`loading-${i}`" class="mobile-category-skeleton"></div>
          </div>

          <!-- 🔥 실제 카테고리 데이터 - 아코디언 방식 -->
          <div v-else class="mobile-category-accordion">
            <!-- 1차 카테고리 반복 -->
            <div v-for="(category, categoryIndex) in categories"
                 :key="category.id"
                 class="mobile-category-level-1">

              <!-- 1차 카테고리 헤더 -->
              <div class="mobile-category-header-1" @click="toggleMobileCategory(categoryIndex)">
                <img :src="category.icon" alt="카테고리 아이콘" class="mobile-category-icon">
                <span class="mobile-category-name">{{ category.name }}</span>
                <i class="bi" :class="mobileSelectedCategory === categoryIndex ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
              </div>

              <!-- 1차 카테고리 내용 (2차 카테고리들) -->
              <div v-if="mobileSelectedCategory === categoryIndex" class="mobile-category-content-1">
                <!-- 2차 카테고리 반복 -->
                <div v-for="(subCategory, subIndex) in category.subCategories"
                     :key="subCategory.id"
                     class="mobile-category-level-2">

                  <!-- 2차 카테고리 헤더 (클릭 시 아코디언 토글) -->
                  <div class="mobile-category-header-2"
                       @click="toggleMobileSubCategory(subCategory.id)">
                    <router-link :to="{ path: '/products', query: { category: subCategory.id.toString(), keyword: subCategory.title, sort: '인기도' } }"
                                 class="mobile-subcategory-link-header"
                                 @click.stop="closeMenu">
                      <i class="bi bi-folder"></i>
                      <span>{{ subCategory.title }}</span>
                    </router-link>
                    <button class="mobile-accordion-toggle"
                            @click.stop="toggleMobileSubCategory(subCategory.id)"
                            v-if="subCategory.items && subCategory.items.length > 0">
                      <i class="bi" :class="expandedMobileCategories.has(subCategory.id) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                  </div>

                  <!-- 2차 카테고리 내용 (3차/4차 카테고리들) - 아코디언 -->
                  <transition name="mobile-accordion">
                    <div v-if="expandedMobileCategories.has(subCategory.id)"
                         class="mobile-category-content-2">
                      <!-- 3차/4차 카테고리 표시 -->
                      <template v-for="(item, itemIndex) in subCategory.items" :key="item.id">
                        <!-- 🔥 3차 카테고리 -->
                        <div v-if="item.level === 3" class="mobile-third-category">
                          <router-link :to="{ path: '/products', query: { category: item.id.toString(), keyword: item.name, sort: '인기도' } }"
                                       class="mobile-subcategory-link mobile-third-link"
                                       @click="closeMenu">
                            <i class="bi bi-folder2-open"></i>
                            <span>{{ item.name }}</span>
                          </router-link>
                        </div>

                        <!-- 🔥 4차 카테고리 -->
                        <div v-else-if="item.level === 4" class="mobile-fourth-category">
                          <router-link :to="{ path: '/products', query: { category: item.id.toString(), keyword: item.name, sort: '인기도' } }"
                                       class="mobile-subcategory-link mobile-fourth-link"
                                       @click="closeMenu">
                            <span class="mobile-fourth-indent">└</span>
                            <span>{{ item.name.trim() }}</span>
                          </router-link>
                        </div>

                        <!-- 🔥 2차 카테고리만 있는 경우 -->
                        <div v-else-if="item.level === 2" class="mobile-second-category">
                          <router-link :to="{ path: '/products', query: { category: item.id.toString(), keyword: item.name, sort: '인기도' } }"
                                       class="mobile-subcategory-link mobile-second-link"
                                       @click="closeMenu">
                            <i class="bi bi-tag"></i>
                            <span>{{ item.name }}</span>
                          </router-link>
                        </div>
                      </template>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 공통 메뉴 링크 -->
        <!--        <div class="mobile-menu-common-links">-->
        <!--          <a href="/new-products" class="mobile-menu-common-link" @click="closeMenu">-->
        <!--            <img src="@/assets/user/img/free-icon-syringe-1021573.png">-->
        <!--            <span>신상품</span>-->
        <!--          </a>-->
        <!--          <a href="/promotions" class="mobile-menu-common-link" @click="closeMenu">-->
        <!--            <img src="@/assets/user/img/free-icon-giftbox-8762962.png">-->
        <!--            <span>기획전</span>-->
        <!--          </a>-->
        <!--          <a href="/mypage/faq" class="mobile-menu-common-link" @click="closeMenu">-->
        <!--            <img src="@/assets/user/img/free-icon-customer-review-9821148.png">-->
        <!--            <span>고객센터</span>-->
        <!--          </a>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SearchSuggestPanel from '@/components/shop/SearchSuggestPanel.vue';
export default {
  name: 'NebulaHeader',
  components: { SearchSuggestPanel },
  data() {
    return {
      currentTime: '',
      timer: null,
      isBeforeDeadline: true,
      isLoggedIn: false,
// 🔥 스크롤 관련 데이터 추가
      scrollTimer: null,
      isScrolled: false,
      lastScrollY: 0,
      isScrolling: false,

      isFavorited: false, // 즐겨찾기 상태
      favoriteCheckInterval: null, // 즐겨찾기 상태 체크 인터벌

      userName: '',
      cartItemCount: 0, // 장바구니 아이템 수량
      // 슬라이드 관련 데이터 추가
      currentSlide: 0,
      // 🔥 모바일 아코디언용 추가 데이터

      mobileSelectedCategory: 0,
      expandedMobileCategories: new Set(), // 펼쳐진 2차 카테고리 ID들
      promotionSlides: [
        // {
        //   type: 'kakao',
        //   icon: 'bi-chat-fill',
        //   title: '1000포인트 받아가세요~',
        //   subtitle: '카카오채널 친구추가 이벤트',
        //   bgColor: '#FFEB3B',
        //   iconBgColor: '#FEE500'
        // },
        {
          type: 'gift',
          icon: 'bi-gift-fill',
          title: '신규 가입 특별 혜택',
          subtitle: '회원가입 시 5,000원 쿠폰 증정',
          bgColor: '#E3F2FD',
          iconBgColor: '#2196F3'
        },
        {
          type: 'shipping',
          icon: 'bi-truck',
          title: '3만원 이상 무료배송',
          subtitle: '빠르고 안전한 배송서비스',
          bgColor: '#E8F5E9',
          iconBgColor: '#4CAF50'
        }
        // {
        //   type: 'discount',
        //   icon: 'bi-percent',
        //   title: '첫 구매 15% 할인',
        //   subtitle: '신규 회원 전용 특별 혜택',
        //   bgColor: '#FFF3E0',
        //   iconBgColor: '#FF9800'
        // }
      ],
      slideInterval: null,
      loading: true,
      showPromoBanner: true,
      searchQuery: '',
      // 🔥 2026-10-15 검색창 드롭다운
      showSearchSuggest: false,
      suggestAnchor: null,       // 드롭다운 위치 기준(검색창 DOM)
      recentSearches: [],        // [{ keyword, date }]
      popularSearches: [],
      popularLoadedAt: 0,
      popularBasis: '',          // 인기 검색어 기준 시각 (HH:mm)
      searchSaveOff: false,      // 검색어 저장 끄기 (로그인=내 계정, 비로그인=이 브라우저)
      // 🔥 2026-10-19 관리자 검색어 관리 설정 (못 불러오면 아래 기본값 = 예전과 같은 동작)
      searchPlaceholder: '한글성분명, 영어성분명, 제조사 검색',
      suggestShow: { recent: true, popular: true, categories: true },
      suggestPopularDays: 7,
      suggestManualCategories: null,   // 관리자가 직접 지정한 추천 카테고리 (null = 자동)
      showCategoryMenu: false,
      isMobile: false,
      showMobileMenu: false,
      showMobileSearch: false,
      selectedCategoryIndex: 0,
      selectedSubCategoryIndex: 0, // 선택된 2차 카테고리 인덱스
      allSecondCategories: [], // 모든 2차 카테고리 목록

      // 🔥 동적 카테고리 데이터로 변경
      categories: [], // 빈 배열로 시작
      categoryHierarchy: {}, // 카테고리 계층 구조 캐시
      fallbackCategories: [
        // 🔥 API 실패 시 대체용 카테고리 (기존 하드코딩 데이터)
        {
          id: 'fallback-1',
          name: '의약품',
          icon: require('@/assets/user/img/free-icon-medicine-9260582.png'),
          subCategories: [
            {
              title: '주사제',
              items: [
                { id: 'fb-2011', name: '급여 주사제' },
                { id: 'fb-2012', name: '비급여 주사제' },
                { id: 'fb-2013', name: '주사형 의료기기' }
              ]
            }
            // ... 기타 대체용 서브카테고리
          ]
        },
        {
          id: 'fallback-2',
          name: '의료소모품',
          icon: require('@/assets/user/img/free-icon-pills-6146539.png'),
          subCategories: [
            // ... 대체용 서브카테고리
          ]
        }
      ]
    };
  },
  computed: {
    // 🔥 2026-10-15 검색 드롭다운 추천 카테고리 (헤더가 이미 불러온 2차 카테고리 앞쪽 10개)
    suggestCategories() {
      // 2026-10-19 관리자가 직접 지정했으면 그 목록, 아니면 예전처럼 2차 카테고리 앞쪽 10개
      if (Array.isArray(this.suggestManualCategories)) return this.suggestManualCategories;
      return (this.allSecondCategories || [])
          .filter(c => c && c.id != null && c.title)
          .slice(0, 10)
          .map(c => ({ id: c.id, title: c.title }));
    },
    // 헤더 출고 배너 문구 (관리자 설정값 우선, 미로드/실패 시 기본값)
    shippingDayTitle() {
      try {
        const g = this.$store && this.$store.getters && this.$store.getters['shippingBanner/dayTitle'];
        if (g) return g;
      } catch (e) { /* ignore */ }
      return '지금 주문 시 당일출고 가능';
    },
    shippingDaySubtitle() {
      let tpl;
      try {
        tpl = this.$store && this.$store.getters && this.$store.getters['shippingBanner/daySubtitleTemplate'];
      } catch (e) { /* ignore */ }
      const template = tpl || '현재 시각 {time} 주문 기준';
      return template.replace('{time}', this.currentTime || '');
    },
    shippingNightTitle() {
      try {
        const g = this.$store && this.$store.getters && this.$store.getters['shippingBanner/nightTitle'];
        if (g) return g;
      } catch (e) { /* ignore */ }
      return '지금 주문 시 다음 영업일 출고';
    },
    shippingNightSubtitle() {
      try {
        const g = this.$store && this.$store.getters && this.$store.getters['shippingBanner/nightSubtitle'];
        if (g) return g;
      } catch (e) { /* ignore */ }
      return '평일 오후 2:30 출고 마감';
    },
    selectedCategory() {
      return this.categories[this.selectedCategoryIndex];
    },
    selectedSubCategory() {
      return this.allSecondCategories[this.selectedSubCategoryIndex];
    },
    // 🔥 새로 추가: 3차/4차 카테고리 그룹화
    groupedItems() {
      if (!this.selectedSubCategory || !this.selectedSubCategory.items) {
        return [];
      }

      const grouped = [];
      const items = this.selectedSubCategory.items;

      // 3차 카테고리별로 그룹화
      const thirdLevelMap = new Map();

      items.forEach(item => {
        if (item.level === 3) {
          // 3차 카테고리
          if (!thirdLevelMap.has(item.id)) {
            thirdLevelMap.set(item.id, {
              ...item,
              children: []
            });
          }
        } else if (item.level === 4) {
          // 4차 카테고리 - 부모 3차 찾기
          const parentId = item.parentId;
          if (thirdLevelMap.has(parentId)) {
            thirdLevelMap.get(parentId).children.push(item);
          }
        } else if (item.level === 2) {
          // 2차만 있는 경우
          grouped.push(item);
        }
      });

      // 3차 카테고리들을 배열로 변환
      thirdLevelMap.forEach(group => {
        grouped.push(group);
      });

      return grouped;
    }
  },
  async created() {
    // 초기 모바일 상태 확인
    this.checkIsMobile();
    // 로그인 상태 확인
    this.checkLoginStatus();
    // 🔥 카테고리 데이터 로드 (주석 해제 및 수정)
    await this.fetchCategories();
    // 장바구니 수량 가져오기
    this.fetchCartItemCount();
  },

  async mounted() {
    // 공휴일 캐시 로드 (헤더 낮밤 배너의 공휴일 분기 판단용)
    // 실패해도 요일만으로 fallback 동작하므로 await 없이 발사
    try { this.$store.dispatch('holiday/ensureLoaded'); } catch (e) { /* ignore */ }
    // 헤더 출고 배너 문구 로드 (관리자가 설정한 문구. 실패 시 기본값 fallback)
    try { this.$store.dispatch('shippingBanner/ensureLoaded'); } catch (e) { /* ignore */ }
    // 🔥 2026-10-19 검색창 안내 문구·드롭다운 설정 (실패해도 기본값으로 그대로 동작)
    this.loadSuggestConfig();
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
    // 🔥 즐겨찾기 상태 체크 시작
    this.startFavoriteCheck();
    // 슬라이드쇼 시작
    this.startSlideShow();
    // 🔥 카테고리 로드 완료 후 로딩 해제
    setTimeout(() => {
      this.loading = false;
    }, 1000); // 카테고리 로드 시간 고려

    // 기타 이벤트 리스너...
    document.addEventListener('click', this.handleOutsideClick);
    window.addEventListener('resize', this.handleResize);

    // 🔥 안전한 스크롤 이벤트 리스너 추가
    this.initScrollHandler();

    // 🔥 스크롤 이벤트 리스너 추가
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount() {
    clearInterval(this.timer);
    // 🔥 즐겨찾기 체크 중지
    this.stopFavoriteCheck();
    // 슬라이드쇼 중지
    this.stopSlideShow();
    // 컴포넌트 제거 시 이벤트 리스너 제거
    document.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('resize', this.handleResize);
// 🔥 안전한 스크롤 이벤트 리스너 제거
    this.destroyScrollHandler();
    // 🔥 스크롤 이벤트 리스너 제거
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    updateTime() {
      const now = new Date();
      const hours = now.getHours();
      const rawMinutes = now.getMinutes();
      const minutes = String(rawMinutes).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      // 14시 30분 기준 컷오프
      const beforeCutoff = hours < 14 || (hours === 14 && rawMinutes <= 30);
      // 주말 / 공휴일 / 평일 14:31 이후 → 밤 배너(다음 영업일 출고)
      // 평일 00:00~14:30 → 낮 배너(당일출고 가능)
      const dow = now.getDay();
      const isWeekend = dow === 0 || dow === 6;
      let isHolidayToday = false;
      try {
        const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        const fn = this.$store && this.$store.getters && this.$store.getters['holiday/isHoliday'];
        if (typeof fn === 'function') isHolidayToday = !!fn(todayStr);
      } catch (e) { /* store 미로드 시 요일만으로 fallback */ }
      this.isBeforeDeadline = beforeCutoff && !isWeekend && !isHolidayToday;
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    },
    // 🔥 안전한 스크롤 핸들러 초기화
    initScrollHandler() {
      try {
        if (typeof window !== 'undefined' && window.addEventListener) {
          // 🔥 패시브 이벤트 리스너로 성능 개선
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          console.log('🎯 스크롤 이벤트 리스너 등록 완료');
        }
      } catch (error) {
        console.warn('⚠️ 스크롤 이벤트 리스너 등록 실패:', error);
      }
    },

    // 🔥 안전한 스크롤 핸들러 제거
    destroyScrollHandler() {
      try {
        if (typeof window !== 'undefined' && window.removeEventListener) {
          window.removeEventListener('scroll', this.handleScroll);

          // 🔥 타이머 정리
          if (this.scrollTimer) {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = null;
          }

          console.log('🎯 스크롤 이벤트 리스너 제거 완료');
        }
      } catch (error) {
        console.warn('⚠️ 스크롤 이벤트 리스너 제거 실패:', error);
      }
    },
    // 🔥 개선된 스크롤 이벤트 핸들러 (안전성 강화)
    handleScroll() {
      //    이미 스크롤 처리 중이면 무시
      if (this.isScrolling) {
        return;
      }

      //    안전한 디바운싱 (시간 증가)
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      this.scrollTimer = setTimeout(() => {
        this.updateScrollState();
      }, 150); // 🔥 150ms로 증가하여 더 안정적으로
    },

    // 🔥 스크롤 상태 업데이트 (분리된 메서드)
    updateScrollState() {
      try {
        this.isScrolling = true;

        // 🔥 안전한 스크롤 위치 가져오기
        const scrollY = this.getScrollPosition();
        if (scrollY === null) {
          return;
        }

        // 🔥 헤더 요소 안전하게 가져오기
        const header = this.getHeaderElement();
        if (!header) {
          return;
        }

        //    임계값 증가 및 히스테리시스 추가
        const SCROLL_THRESHOLD = 100; // 🔥 임계값 증가
        const HYSTERESIS = 50; //    히스테리시스 증가

        let shouldBeScrolled;

        if (this.isScrolled) {
          // 현재 스크롤된 상태라면, 더 아래로 스크롤해야 해제
          shouldBeScrolled = scrollY > (SCROLL_THRESHOLD - HYSTERESIS);
        } else {
          // 현재 스크롤되지 않은 상태라면, 더 위로 스크롤해야 적용
          shouldBeScrolled = scrollY > (SCROLL_THRESHOLD + HYSTERESIS);
        }

        // 🔥 상태가 실제로 변경될 때만 업데이트
        if (shouldBeScrolled !== this.isScrolled) {
          this.isScrolled = shouldBeScrolled;

          // 🔥 안전한 DOM 조작
          this.applyScrollClass(header, shouldBeScrolled);
        }

        // 🔥 스크롤 위치 업데이트
        this.lastScrollY = scrollY;

      } catch (error) {
        console.warn('⚠️ 스크롤 상태 업데이트 실패:', error);
      } finally {
        //    스크롤 처리 완료 (시간 증가)
        setTimeout(() => {
          this.isScrolling = false;
        }, 100); //    100ms로 증가
      }
    },

// 🔥 안전한 스크롤 위치 가져오기
    getScrollPosition() {
      try {
        if (typeof window === 'undefined') {
          return null;
        }

        return Math.max(
            window.pageYOffset || 0,
            document.documentElement.scrollTop || 0,
            document.body.scrollTop || 0
        );
      } catch (error) {
        console.warn('⚠️ 스크롤 위치 가져오기 실패:', error);
        return null;
      }
    },

    // 🔥 안전한 헤더 요소 가져오기
    getHeaderElement() {
      try {
        if (typeof document === 'undefined') {
          return null;
        }

        return document.querySelector('.nebula-header-wrapper');
      } catch (error) {
        console.warn('⚠️ 헤더 요소 가져오기 실패:', error);
        return null;
      }
    },

// 🔥 안전한 스크롤 클래스 적용
    applyScrollClass(header, shouldBeScrolled) {
      try {
        if (!header || typeof header.classList === 'undefined') {
          return;
        }

        // 🔥 requestAnimationFrame으로 부드러운 애니메이션
        requestAnimationFrame(() => {
          try {
            if (shouldBeScrolled) {
              if (!header.classList.contains('scrolled')) {
                header.classList.add('scrolled');
              }
            } else {
              if (header.classList.contains('scrolled')) {
                header.classList.remove('scrolled');
              }
            }
          } catch (error) {
            console.warn('⚠️ 클래스 적용 실패:', error);
          }
        });

      } catch (error) {
        console.warn('⚠️ 스크롤 클래스 적용 실패:', error);
      }
    },

    // 🔥 닥터마켓 즐겨찾기 기능
    toggleFavorite() {
      if (this.isFavorited) {
        this.removeFavorite();
      } else {
        this.addFavorite();
      }
    },
// 🔥 즐겨찾기 추가
    addFavorite() {
      try {
        // 브라우저 즐겨찾기에 추가하는 방법
        if (window.sidebar && window.sidebar.addPanel) {
          // Firefox
          window.sidebar.addPanel('닥터마켓', window.location.href, '');
        } else if (window.external && window.external.AddFavorite) {
          // Internet Explorer
          window.external.AddFavorite(window.location.href, '닥터마켓');
        } else {
          // 다른 브라우저의 경우 안내 메시지
          this.showFavoriteInstructions();
        }

        // 로컬 스토리지에 즐겨찾기 상태 저장
        localStorage.setItem('doctormarket_favorited', 'true');
        this.isFavorited = true;

        // 성공 메시지
        this.showMessage('즐겨찾기에 추가되었습니다!', 'success');

      } catch (error) {
        console.error('즐겨찾기 추가 실패:', error);
        this.showFavoriteInstructions();
      }
    },
// 🔥 즐겨찾기 제거
    removeFavorite() {
      try {
        // 브라우저 즐겨찾기는 직접 제거가 어려우므로 안내 메시지
        this.showRemoveFavoriteInstructions();

        // 로컬 스토리지에서 제거
        localStorage.removeItem('doctormarket_favorited');
        this.isFavorited = false;

      } catch (error) {
        console.error('즐겨찾기 제거 실패:', error);
      }
    },
    // 🔥 즐겨찾기 추가 안내
    showFavoriteInstructions() {
      const userAgent = navigator.userAgent.toLowerCase();
      let instructions = '';

      if (userAgent.includes('chrome')) {
        instructions = 'Chrome: Ctrl+D (Windows/Linux) 또는 ⌘+D (Mac)를 눌러 즐겨찾기에 추가해주세요.';
      } else if (userAgent.includes('firefox')) {
        instructions = 'Firefox: Ctrl+D (Windows/Linux) 또는 ⌘+D (Mac)를 눌러 북마크에 추가해주세요.';
      } else if (userAgent.includes('safari')) {
        instructions = 'Safari: ⌘+D를 눌러 북마크에 추가해주세요.';
      } else if (userAgent.includes('edge')) {
        instructions = 'Edge: Ctrl+D를 눌러 즐겨찾기에 추가해주세요.';
      } else {
        instructions = '브라우저 메뉴에서 "즐겨찾기 추가" 또는 "북마크 추가"를 선택해주세요.';
      }

      this.showMessage(instructions, 'info', 5000);
    },

    // 🔥 즐겨찾기 제거 안내
    showRemoveFavoriteInstructions() {
      this.showMessage('브라우저 즐겨찾기 메뉴에서 "닥터마켓"을 직접 삭제해주세요.', 'info', 3000);
    },

    // 🔥 메시지 표시
    showMessage(message, type = 'info', duration = 3000) {
      // 메시지를 표시하는 간단한 토스트 알림
      const toast = document.createElement('div');
      toast.className = `favorite-toast favorite-toast-${type}`;
      toast.textContent = message;
      toast.style.cssText = `
      position: fixed;
      top: 100px;
      right: 20px;
      background: ${type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#17a2b8'};
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      z-index: 9999;
      font-size: 14px;
      max-width: 300px;
      word-wrap: break-word;
      animation: slideInRight 0.3s ease;
    `;

      document.body.appendChild(toast);

      setTimeout(() => {
        if (toast.parentNode) {
          toast.style.animation = 'slideOutRight 0.3s ease';
          setTimeout(() => {
            if (toast.parentNode) {
              toast.parentNode.removeChild(toast);
            }
          }, 300);
        }
      }, duration);
    },

    // 🔥 즐겨찾기 상태 확인
    checkFavoriteStatus() {
      const favorited = localStorage.getItem('doctormarket_favorited');
      this.isFavorited = favorited === 'true';
    },

    // 🔥 즐겨찾기 상태 주기적 체크
    startFavoriteCheck() {
      this.checkFavoriteStatus();

      // 5초마다 즐겨찾기 상태 체크 (사용자가 직접 브라우저에서 추가/제거할 수 있으므로)
      this.favoriteCheckInterval = setInterval(() => {
        this.checkFavoriteStatus();
      }, 5000);
    },

    // 🔥 즐겨찾기 체크 중지
    stopFavoriteCheck() {
      if (this.favoriteCheckInterval) {
        clearInterval(this.favoriteCheckInterval);
        this.favoriteCheckInterval = null;
      }
    },

    // 🔥 모바일 1차 카테고리 토글
    toggleMobileCategory(index) {
      // 🔥 이미 선택된 카테고리를 클릭하면 접기, 아니면 선택
      if (this.mobileSelectedCategory === index) {
        this.mobileSelectedCategory = -1; // 접기
      } else {
        this.mobileSelectedCategory = index; // 새 카테고리 선택
        this.expandedMobileCategories.clear(); // 새 카테고리 선택 시 모든 2차 아코디언 접기
      }
    },
// 🔥 모바일 2차 카테고리 아코디언 토글
    toggleMobileSubCategory(subCategoryId) {
      if (this.expandedMobileCategories.has(subCategoryId)) {
        this.expandedMobileCategories.delete(subCategoryId); // 접기
      } else {
        this.expandedMobileCategories.add(subCategoryId); // 펼치기
      }
      // Vue의 반응성을 위해 새로운 Set 객체 생성
      this.expandedMobileCategories = new Set(this.expandedMobileCategories);
    },

    // 🔥 관리자에서 등록된 카테고리 데이터 로드
    async fetchCategories() {
      try {
        console.log('카테고리 데이터 로드 시작...');

        // 1차 카테고리만 먼저 로드
        const response = await axios.get('/api/admin/categories');

        // 활성화된 카테고리만 필터링
        const activeCategories = response.data.filter(cat => cat.active === true);

        // 1차 카테고리 필터링 (parentId가 없는 활성화된 카테고리)
        const firstLevelCategories = activeCategories.filter(cat => !cat.parentId);

        // 활성화된 카테고리를 계층 구조로 캐싱
        this.categoryHierarchy = {};
        activeCategories.forEach(cat => {
          this.categoryHierarchy[cat.id] = cat;
        });

        // 1차 카테고리와 2차 카테고리를 매핑
        const categoriesWithSub = [];

        for (const firstLevel of firstLevelCategories) {
          // 각 1차 카테고리에 대해 2차 카테고리 로드
          const subCategoryData = await this.loadSubCategories(firstLevel.id);

          categoriesWithSub.push({
            id: firstLevel.id,
            name: firstLevel.name,
            icon: this.getCategoryIcon(firstLevel.name), // 아이콘 매핑
            subCategories: subCategoryData
          });
        }

        this.categories = categoriesWithSub;

        // 🔥 모든 2차 카테고리를 하나의 배열로 통합 (왼쪽 패널용)
        this.buildAllSecondCategories();

        console.log('카테고리 로드 완료:', this.categories);
        console.log('2차 카테고리 목록:', this.allSecondCategories);

      } catch (error) {
        console.error('카테고리 로드 실패:', error);
        // 🔥 API 실패 시 대체용 데이터 사용
        this.categories = this.fallbackCategories;
        this.buildAllSecondCategories(); // 대체 데이터에서도 2차 카테고리 추출
        console.log('대체용 카테고리 사용');
      }
    },
// 🔥 새로 추가: 모든 2차 카테고리를 하나의 배열로 만들기
    buildAllSecondCategories() {
      this.allSecondCategories = [];

      this.categories.forEach(category => {
        category.subCategories.forEach(subCat => {
          this.allSecondCategories.push({
            ...subCat,
            parentId: category.id,
            parentName: category.name,
            parentIcon: category.icon // 부모 카테고리 아이콘도 포함
          });
        });
      });

      console.log('통합된 2차 카테고리 수:', this.allSecondCategories.length);
    },
    // 🔥 2차 카테고리와 하위 항목들 로드
    async loadSubCategories(parentId) {
      try {
        const response = await axios.get(`/api/admin/categories/parent/${parentId}`);
        // 활성화된 2차 카테고리만 필터링
        const secondLevelCategories = response.data.filter(cat => cat.active === true);

        const subCategories = [];

        for (const secondLevel of secondLevelCategories) {
          // 각 2차 카테고리에 대해 3차 카테고리 로드
          const thirdLevelResponse = await axios.get(`/api/admin/categories/parent/${secondLevel.id}`);
          // 활성화된 3차 카테고리만 필터링
          const thirdLevelCategories = thirdLevelResponse.data.filter(cat => cat.active === true);

          const items = [];

          // 🔥 3차 카테고리가 있는 경우
          if (thirdLevelCategories.length > 0) {
            for (const thirdLevel of thirdLevelCategories) {
              // 🔥 먼저 3차 카테고리 자체를 추가
              items.push({
                id: thirdLevel.id,
                name: thirdLevel.name,
                parentId: secondLevel.id,
                parentName: secondLevel.name,
                level: 3 // 3차 레벨
              });

              // 🔥 그 다음에 4차 카테고리 확인 및 추가
              try {
                const fourthLevelResponse = await axios.get(`/api/admin/categories/parent/${thirdLevel.id}`);
                // 활성화된 4차 카테고리만 필터링
                const fourthLevelCategories = fourthLevelResponse.data.filter(cat => cat.active === true);

                if (fourthLevelCategories.length > 0) {
                  // 4차 카테고리가 있으면 4차들도 추가
                  fourthLevelCategories.forEach(fourthLevel => {
                    items.push({
                      id: fourthLevel.id,
                      name: `    ${fourthLevel.name}`, // 🔥 들여쓰기로 4차임을 표시
                      parentId: thirdLevel.id,
                      parentName: thirdLevel.name,
                      level: 4, // 4차 레벨
                      isSubItem: true // 🔥 하위 항목임을 표시
                    });
                  });
                }
              } catch (error) {
                console.error(`4차 카테고리 로드 실패 (parentId: ${thirdLevel.id}):`, error);
                // 4차 로드 실패해도 3차는 이미 추가되었으므로 계속 진행
              }
            }
          } else {
            // 🔥 3차 카테고리가 없으면 2차만 추가
            items.push({
              id: secondLevel.id,
              name: secondLevel.name,
              parentId: parentId,
              parentName: this.categoryHierarchy[parentId]?.name,
              level: 2 // 2차 레벨
            });
          }

          if (items.length > 0) {
            subCategories.push({
              id: secondLevel.id,
              title: secondLevel.name, // 2차 카테고리 이름이 title
              items: items
            });
          }
        }

        return subCategories;

      } catch (error) {
        console.error(`2차 카테고리 로드 실패 (parentId: ${parentId}):`, error);
        return [];
      }
    },

    // 🔥 카테고리 이름에 따른 아이콘 매핑 (개선된 버전)
    getCategoryIcon(categoryName) {
      console.log('🔍 카테고리 아이콘 매핑 확인:', `"${categoryName}"`);

      const iconMapping = {
        // 🔥 의약품 - 약병 아이콘 (medicine)
        '의약품': require('@/assets/user/img/free-icon-medicine-9260582.png'),

        // 🔥 의료소모품 - 선물상자 아이콘 (giftbox)
        '의료소모품': require('@/assets/user/img/free-icon-giftbox-8762962.png'),

        // 🔥 백엔드에서 "전체 카테고리"로 오는 경우도 처리
        '전체 카테고리': require('@/assets/user/img/free-icon-giftbox-8762962.png'),

        // 🔥 다른 가능한 이름들
        '의약': require('@/assets/user/img/free-icon-medicine-9260582.png'),
        '외품': require('@/assets/user/img/free-icon-giftbox-8762962.png'),
        '건강': require('@/assets/user/img/free-icon-giftbox-8762962.png'),
        '의약/건강': require('@/assets/user/img/free-icon-giftbox-8762962.png'),

        // 🔥 기타 카테고리들
        '의료기기': require('@/assets/user/img/free-icon-medicines-706169.png'),
        '미용/성형': require('@/assets/user/img/free-icon-syringe-1021573.png'),
        '위생/소독': require('@/assets/user/img/free-icon-customer-review-9821148.png'),
      };

      const selectedIcon = iconMapping[categoryName];
      console.log('🎯 아이콘 매핑 결과:', categoryName, '->', selectedIcon ? '매핑 성공' : '기본값 사용');

      return selectedIcon || require('@/assets/user/img/free-icon-medicine-9260582.png');
    },

    selectSubCategory(index) {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(() => {
        this.selectedSubCategoryIndex = index;
      }, 50); // 50ms 디바운스 적용
    },
// 🔥 새로 추가: 2차 카테고리 아이콘 가져오기
    getSubCategoryIcon(parentName) {
      return this.getCategoryIcon(parentName);
    },

    // 🔥 카테고리 메뉴 닫기
    closeCategoryMenu() {
      this.showCategoryMenu = false;
    },

    // 🔥 카테고리별 상품 페이지로 이동
    goToCategoryPage(categoryId, categoryName = '') {
      this.$router.push({
        path: '/products',
        query: {
          category: categoryId.toString(),
          keyword: categoryName,
          sort: '인기도'
        }
      });
      this.closeCategoryMenu();
    },

    // 🔥 서브카테고리 페이지로 이동
    goToSubcategoryPage(item) {
      this.$router.push({
        path: '/products',
        query: {
          category: item.id.toString(),
          keyword: item.name,
          sort: '인기도'
        }
      });
      this.closeCategoryMenu();
    },

    // 로그인 상태 확인
    checkLoginStatus() {
      // 🔥 사용자는 sessionStorage 사용 (브라우저 닫으면 로그아웃)
      const token = sessionStorage.getItem('auth_token');
      const userInfo = sessionStorage.getItem('user_info');

      if (token && userInfo) {
        const user = JSON.parse(userInfo);
        this.isLoggedIn = true;
        this.userName = user.name || '사용자';
        this.fetchCartItemCount();
      } else {
        this.isLoggedIn = false;
        this.userName = '';
      }
    },
    // 장바구니 수량 가져오기
    fetchCartItemCount() {
      // 로그인한 상태일 때만 API 호출
      if (this.isLoggedIn) {
        // 🔥 사용자는 sessionStorage 사용
        const token = sessionStorage.getItem('auth_token');

        axios.get('/api/user/cart', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
            .then(response => {
              if (response.data && response.data.items) {
                // 장바구니에 있는 모든 아이템 수량 합계
                this.cartItemCount = response.data.items.length;
              } else {
                this.cartItemCount = 0;
              }
            })
            .catch(error => {
              console.error('장바구니 정보를 가져오는 중 오류 발생:', error);
              this.cartItemCount = 0;
            });
      } else {
        // 로그인하지 않은 경우 로컬 스토리지의 장바구니 확인 (필요시 구현)
        const localCart = localStorage.getItem('guest_cart');
        if (localCart) {
          try {
            const cartData = JSON.parse(localCart);
            this.cartItemCount = cartData.length || 0;
          } catch (e) {
            this.cartItemCount = 0;
          }
        } else {
          this.cartItemCount = 0;
        }
      }
    },
    // 로그아웃 처리
    handleLogout() {
      // 🔥 사용자는 sessionStorage 사용
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('user_info');

      // 로그인 상태 업데이트
      this.isLoggedIn = false;
      this.userName = '';
      this.cartItemCount = 0; // 장바구니 수량 초기화

      // 로그인 페이지로 이동
      this.$router.push('/login');
    },
// 슬라이드 관련 메서드
    nextSlide() {
      // 애니메이션이 끝나면 다음 슬라이드로 이동
      this.currentSlide = (this.currentSlide + 1) % this.promotionSlides.length;

      // 강제로 DOM 업데이트 (Vue의 반응형 시스템 강제 업데이트)
      this.$nextTick(() => {
        const container = document.querySelector('.nebula-slide-container');
        if (container) {
          container.style.transform = `translateX(-${this.currentSlide * 25}%)`;
        }
      });
    },

    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.promotionSlides.length) % this.promotionSlides.length;

      this.$nextTick(() => {
        const container = document.querySelector('.nebula-slide-container');
        if (container) {
          container.style.transform = `translateX(-${this.currentSlide * 25}%)`;
        }
      });
    },

    goToSlide(index) {
      this.currentSlide = index;

      this.$nextTick(() => {
        const container = document.querySelector('.nebula-slide-container');
        if (container) {
          container.style.transform = `translateX(-${this.currentSlide * 25}%)`;
        }
      });
    },

    startSlideShow() {
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000); // 5초마다 슬라이드 변경
    },

    stopSlideShow() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
      }
    },
    closePromoBanner() {
      this.showPromoBanner = false;
      // 실제 구현에서는 쿠키나 로컬 스토리지에 1일간 보지 않기 상태 저장
    },
    searchProducts() {
      if (this.searchQuery.trim() !== '') {
        const newSearch = this.searchQuery.trim();
        // 🔥 2026-10-19 최근 검색어 저장 — 로그인=서버(내 계정, PC·모바일 공통), 비로그인=이 브라우저
        //   저장 실패해도 검색은 그대로 진행된다
        this.saveRecentSearch(newSearch);

        // 페이지 이동
        this.$router.push({
          path: '/products',
          query: {
            keyword: newSearch,
            sort: '인기도'
          }
        });

        this.searchQuery = '';
        this.showSearchSuggest = false;

        if (this.showMobileSearch) {
          this.showMobileSearch = false;
        }
      } else {
        alert('검색어를 입력해주세요.');
      }
    },
    toggleCategoryMenu(event) {
      event.stopPropagation();
      this.showCategoryMenu = !this.showCategoryMenu;
    },
    // 기존 selectCategory 메서드 대신 이렇게 변경
    selectCategory(index) {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(() => {
        this.selectedCategoryIndex = index;
      }, 50); // 50ms 디바운스 적용
    },
// 🔥 모바일 카테고리 선택 메서드 개선
    selectMobileCategory(index) {
      console.log('모바일 카테고리 선택 시도:', index, this.categories[index]);

      if (this.categories && this.categories[index]) {
        this.mobileSelectedCategory = index;
        console.log('선택된 카테고리:', this.categories[index]);
        console.log('서브카테고리:', this.categories[index].subCategories);
      } else {
        console.error('카테고리 데이터가 없습니다:', index);
      }
    },

    handleOutsideClick(event) {
      const dropdown = document.querySelector('.nebula-category-dropdown');
      if (dropdown && !dropdown.contains(event.target) && this.showCategoryMenu) {
        this.showCategoryMenu = false;
      }
      // 🔥 2026-10-15 검색창 · 드롭다운(body 에 떠 있음) 밖을 누르면 닫기
      if (this.showSearchSuggest && event.target && event.target.closest
          && !event.target.closest('.nebula-search-bar, .mobile-search-container, .nb-sp')) {
        this.showSearchSuggest = false;
      }
    },
    // 🔥 2026-10-15 검색창 드롭다운 — 최근 검색어 + 인기 검색어 + 추천 카테고리
    // 🔥 2026-10-19 최근 검색어: 로그인=서버(내 계정만, PC·모바일 같은 목록) / 비로그인=이 브라우저
    //   예전 공용 저장(searchHistory)은 계정 구분이 없어 다른 사람 검색어가 보였으므로 더 이상 읽지 않는다
    openSearchSuggest(event) {
      const el = event && event.target && event.target.closest
          ? event.target.closest('.nebula-search-bar, .mobile-search-wrapper') : null;
      if (el) this.suggestAnchor = el;
      this.loadRecentSearches();
      this.showSearchSuggest = true;
      if (Date.now() - this.popularLoadedAt > 5 * 60 * 1000) {
        this.loadSuggestConfig();
      }
    },
    hasUserToken() {
      try { return !!sessionStorage.getItem('auth_token'); } catch (e) { return false; }
    },
    formatSearchDate(t) {
      const d = t ? new Date(t) : null;
      return d && !isNaN(d) ? `${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}` : '';
    },
    // 비로그인 전용 브라우저 저장
    guestHistoryRead() {
      try {
        const list = JSON.parse(localStorage.getItem('searchHistory_guest') || '[]');
        const at = JSON.parse(localStorage.getItem('searchHistoryAt_guest') || '{}') || {};
        return { list: Array.isArray(list) ? list : [], at };
      } catch (e) {
        return { list: [], at: {} };
      }
    },
    guestHistoryWrite(list, at) {
      try {
        localStorage.setItem('searchHistory_guest', JSON.stringify(list));
        localStorage.setItem('searchHistoryAt_guest', JSON.stringify(at));
      } catch (e) { /* ignore */ }
    },
    async loadRecentSearches() {
      if (!this.hasUserToken()) {
        try { this.searchSaveOff = localStorage.getItem('searchHistoryOff_guest') === 'Y'; } catch (e) { this.searchSaveOff = false; }
        const { list, at } = this.guestHistoryRead();
        this.recentSearches = list.slice(0, 10).map(k => ({ keyword: k, date: this.formatSearchDate(at[k]) }));
        return;
      }
      try {
        const res = await axios.get('/api/user/search/recent');
        const items = (res.data && Array.isArray(res.data.items)) ? res.data.items : [];
        this.recentSearches = items.map(r => ({ keyword: r.keyword, date: this.formatSearchDate(r.searchedAt) }));
        this.searchSaveOff = !!(res.data && res.data.saveOff);
      } catch (e) {
        this.recentSearches = [];   // 실패해도 검색창은 그대로 쓸 수 있다
      }
    },
    saveRecentSearch(keyword) {
      if (!keyword) return;
      if (this.hasUserToken()) {
        // 서버가 "저장 끄기" 여부를 확인하고 저장한다. 결과를 기다리지 않는다(검색 이동이 늦어지지 않게)
        axios.post('/api/user/search/recent', { keyword }).catch(() => { /* ignore */ });
        return;
      }
      let off = false;
      try { off = localStorage.getItem('searchHistoryOff_guest') === 'Y'; } catch (e) { off = false; }
      if (off) return;
      const { list, at } = this.guestHistoryRead();
      const updated = [keyword, ...list.filter(k => k !== keyword)].slice(0, 10);
      at[keyword] = Date.now();
      Object.keys(at).forEach(k => { if (!updated.includes(k)) delete at[k]; });
      this.guestHistoryWrite(updated, at);
    },
    // 관리자 검색어 관리 설정 + 인기 검색어 + 추천 카테고리 (5분 캐시)
    async loadSuggestConfig() {
      this.popularLoadedAt = Date.now();
      const now = new Date();
      this.popularBasis = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      try {
        const res = await axios.get('/api/search/suggest');
        const d = res.data || {};
        this.suggestShow = {
          recent: d.showRecent !== false,
          popular: d.showPopular !== false,
          categories: d.showCategories !== false
        };
        if (d.popularDays) this.suggestPopularDays = d.popularDays;
        if (d.placeholder) this.searchPlaceholder = d.placeholder;
        this.suggestManualCategories = d.categoryMode === 'MANUAL' && Array.isArray(d.categories)
            ? d.categories.map(c => ({ id: 'm' + c.id, title: c.title, linkType: c.linkType, categoryId: c.categoryId, linkValue: c.linkValue }))
            : null;
        this.popularSearches = Array.isArray(d.popular) ? d.popular : [];
      } catch (e) {
        // 새 설정을 못 불러오면 예전 방식 그대로
        this.loadPopularSearches();
      }
    },
    async loadPopularSearches() {
      const token = sessionStorage.getItem('auth_token');
      if (!token) return;   // 상품 API 는 로그인 사용자 전용이라 비로그인은 최근 검색어만
      try {
        const res = await axios.get('/api/products/search-keywords/popular', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.popularSearches = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.popularSearches = [];   // 실패해도 검색창은 그대로 쓸 수 있다
      }
    },
    pickSuggest(keyword) {
      this.searchQuery = keyword;
      this.showSearchSuggest = false;
      this.searchProducts();
    },
    // 추천 카테고리 — 헤더 카테고리 메뉴와 같은 이동 방식
    // 2026-10-19 관리자 직접 지정: CATEGORY(카테고리) / KEYWORD(검색어로 검색) / URL(주소 이동)
    pickSuggestCategory(c) {
      if (c && c.linkType === 'KEYWORD' && c.linkValue) {
        this.pickSuggest(c.linkValue);
        return;
      }
      this.showSearchSuggest = false;
      if (this.showMobileSearch) this.showMobileSearch = false;
      if (c && c.linkType === 'URL' && c.linkValue) {
        if (/^https?:\/\//i.test(c.linkValue)) window.open(c.linkValue, '_blank', 'noopener');
        else this.$router.push(c.linkValue);
        return;
      }
      const categoryId = c && c.linkType === 'CATEGORY' ? c.categoryId : c.id;
      this.$router.push({ path: '/products', query: { category: String(categoryId), keyword: c.title, sort: '인기도' } });
    },
    removeRecentSearch(keyword) {
      this.recentSearches = this.recentSearches.filter(r => r.keyword !== keyword);
      if (this.hasUserToken()) {
        axios.delete('/api/user/search/recent', { params: { keyword } }).catch(() => { /* ignore */ });
        return;
      }
      const { list, at } = this.guestHistoryRead();
      delete at[keyword];
      this.guestHistoryWrite(list.filter(k => k !== keyword), at);
    },
    clearRecentSearches() {
      this.recentSearches = [];
      if (this.hasUserToken()) {
        axios.delete('/api/user/search/recent/all').catch(() => { /* ignore */ });
        return;
      }
      try {
        localStorage.removeItem('searchHistory_guest');
        localStorage.removeItem('searchHistoryAt_guest');
      } catch (e) { /* ignore */ }
    },
    toggleSearchSave() {
      this.searchSaveOff = !this.searchSaveOff;
      if (this.hasUserToken()) {
        axios.put('/api/user/search/save-setting', { saveOff: this.searchSaveOff }).catch(() => { /* ignore */ });
        return;
      }
      try { localStorage.setItem('searchHistoryOff_guest', this.searchSaveOff ? 'Y' : 'N'); } catch (e) { /* ignore */ }
    },
    // 🔥 모바일 메뉴 토글 개선
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;

      if (this.showMobileMenu) {
        this.showMobileSearch = false;
        // 🔥 첫 번째 카테고리를 기본으로 열어둠 (접지 않음)
        if (this.categories && this.categories.length > 0) {
          this.mobileSelectedCategory = 0; // 첫 번째 카테고리 기본 선택
        }
        this.expandedMobileCategories.clear();
        document.body.style.overflow = 'hidden';
        console.log('모바일 메뉴 열기 - 카테고리 수:', this.categories.length);
      } else {
        document.body.style.overflow = '';
        console.log('모바일 메뉴 닫기');
      }
    },

    // 모바일 검색창 토글
    toggleMobileSearch() {
      this.showMobileSearch = !this.showMobileSearch;

      // 검색창이 열리면 메뉴는 닫기
      if (this.showMobileSearch) {
        this.showMobileMenu = false;
      }
    },
    // 창 크기 변경 처리
    handleResize() {
      this.checkIsMobile();

      // 모바일에서 PC로 전환될 때 모바일 메뉴와 검색창 닫기
      if (!this.isMobile) {
        this.showMobileMenu = false;
        this.showMobileSearch = false;
        document.body.style.overflow = '';
      }
    },
    // 모바일 여부 확인
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 🔥 메뉴 닫기 개선
    closeMenu() {
      this.showMobileMenu = false;
      // 🔥 메뉴 닫을 때도 첫 번째 카테고리는 열어둠
      this.mobileSelectedCategory = 0; // -1 대신 0으로 변경
      this.expandedMobileCategories.clear();
      document.body.style.overflow = '';
      console.log('모바일 메뉴 닫기');
    }
  }
};
</script>

<style scoped>
/* 공통 헤더 기본 스타일 */
.nebula-header-wrapper {
  font-family: 'Noto Sans KR', sans-serif;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 🔥 더 부드러운 전환 */
  will-change: box-shadow; /* 🔥 성능 최적화 */
}

/* 🔥 스크롤 시 적용될 클래스 - 더 부드러운 전환 */
.nebula-header-wrapper.scrolled {
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* 🔥 스크롤 시 상단 헤더 숨김 */
.nebula-header-wrapper.scrolled .nebula-top-header {
  max-height: 0;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: none;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 🔥 더 부드러운 전환 곡선 */
}

.nebula-container {
  max-width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 스켈레톤 UI 스타일 */
.nebula-header-skeleton {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}

.nebula-skeleton-promotion-banner {
  background-color: #e0e0e0;
  padding: 10px 0;
}

.nebula-skeleton-promotion-content {
  height: 24px;
  width: 60%;
  margin: 0 auto;
  background-color: #d0d0d0;
  border-radius: 4px;
}

.nebula-skeleton-top-header {
  background-color: white;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}

.nebula-skeleton-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nebula-skeleton-header-left {
  display: flex;
  align-items: center;
}

.nebula-skeleton-logo {
  width: 80px;
  height: 24px;
  background-color: #e0e0e0;
  margin-right: 15px;
  border-radius: 4px;
}

.nebula-skeleton-favorite {
  width: 110px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.nebula-skeleton-header-right {
  display: flex;
  align-items: center;
}

.nebula-skeleton-utility-icons {
  display: flex;
  margin-right: 15px;
}

.nebula-skeleton-icon {
  width: 24px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 50%;
  margin-left: 15px;
}

.nebula-skeleton-auth-buttons {
  display: flex;
}

.nebula-skeleton-btn {
  width: 60px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-left: 10px;
}

.nebula-skeleton-main-header {
  background-color: white;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.nebula-skeleton-main-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nebula-skeleton-main-logo {
  width: 150px;
  height: 60px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.nebula-skeleton-search-bar {
  width: 40%;
  height: 44px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.nebula-skeleton-kakao-promo {
  width: 250px;
  height: 56px;
  background-color: #e0e0e0;
  border-radius: 6px;
}

.nebula-skeleton-main-nav {
  background-color: white;
  padding: 10px 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.nebula-skeleton-nav-content {
  display: flex;
  justify-content: space-between;
}

.nebula-skeleton-primary-nav {
  display: flex;
}

.nebula-skeleton-nav-item {
  width: 100px;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-right: 20px;
}

.nebula-skeleton-secondary-nav {
  display: flex;
}

.nebula-skeleton-nav-item-small {
  width: 70px;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-left: 15px;
}

/* 실제 컨텐츠 페이드인 애니메이션 */
.nebula-header-wrapper > div:not(.nebula-header-skeleton) {
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 프로모션 배너 스타일 */
.nebula-promotion-banner {
  background-color: #4cc3ff;
  color: white;
  padding: 10px 0;
}

.nebula-promotion-content {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.nebula-icon {
  font-size: 24px;
  margin: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nebula-promotion-text {
  font-size: 16px;
  font-weight: 500;
}

.nebula-close-btn {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: white;
  font-size: 12px;
  cursor: pointer;
}

.nebula-close-btn i {
  font-size: 16px;
  margin-left: 5px;
}

/* 상단 헤더 스타일 */
.nebula-top-header {
  max-height: 80px;
  overflow: visible;
  opacity: 1;
  transform: translateY(0);
  background-color: white;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 🔥 더 부드러운 전환 곡선 */
  will-change: max-height, opacity, transform; /* 🔥 성능 최적화 */
}

/* 🔥 메인 헤더 전환 개선 */
.nebula-header-wrapper.scrolled .nebula-main-header {
  padding: 10px 0;
  transition: padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.nebula-header-wrapper.scrolled .nebula-main-nav {
  padding: 8px 0;
  transition: padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 🔥 로고 크기 전환 개선 */
.nebula-header-wrapper.scrolled .nebula-main-logo img {
  max-width: 200px;
  max-height: 40px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 🔥 검색창 전환 개선 */
.nebula-header-wrapper.scrolled .nebula-search-bar {
  width: 35%;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 🔥 프로모션 슬라이드 전환 개선 */
.nebula-header-wrapper.scrolled .nebula-promotion-slide {
  width: 220px;
  height: 50px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
/* 🔥 모바일에서는 더 간소한 전환 */
@media (max-width: 768px) {
  .nebula-header-wrapper.scrolled .nebula-main-logo img {
    max-width: 240px;
    max-height: 42px;
  }

  .nebula-header-wrapper.scrolled .nebula-main-header {
    padding: 12px 0;
  }

  /* 🔥 모바일에서는 상단 헤더 전환 효과 간소화 */
  .nebula-top-header {
    transition: all 0.3s ease; /* 🔥 모바일에서는 더 빠른 전환 */
  }

  .nebula-header-wrapper.scrolled .nebula-top-header {
    transition: all 0.3s ease;
  }
}
/* 🔥 성능 최적화를 위한 GPU 가속 */
.nebula-header-wrapper,
.nebula-top-header,
.nebula-main-header,
.nebula-main-nav,
.nebula-main-logo img,
.nebula-search-bar,
.nebula-promotion-slide {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0); /* 🔥 GPU 가속 활성화 */
}

/* 🔥 부드러운 등장 애니메이션 */
@keyframes headerFadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 🔥 초기 로드 시 부드러운 애니메이션 */
.nebula-header-wrapper:not(.scrolled) .nebula-top-header {
  animation: headerFadeIn 0.6s ease-out;
}

/* 🔥 접근성 개선 - 애니메이션 비활성화 사용자 고려 */
@media (prefers-reduced-motion: reduce) {
  .nebula-header-wrapper,
  .nebula-top-header,
  .nebula-main-header,
  .nebula-main-nav,
  .nebula-main-logo img,
  .nebula-search-bar,
  .nebula-promotion-slide {
    transition: none !important;
    animation: none !important;
  }
}

.nebula-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nebula-header-left {
  display: flex;
  align-items: center;
}

.nebula-logo-link {
  margin-right: 15px;
  text-decoration: none;
}

.nebula-text-logo {
  font-size: 16px;
  font-weight: 600;
  padding: 0px 10px;
  border-radius: 4px;
  text-decoration: none;
}

.supporting-dream {
  color: #3a87ad;
  background-color: #f5f5f5;
}

.doctor-market {
  color: #b12e19;
  background-color: #f5f5f5;
}

.nebula-favorite-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #555;
  font-size: 13px;
  cursor: pointer;
}

.nebula-favorite-btn i {
  color: #ffc107;
  margin-right: 5px;
}

.nebula-header-right {
  display: flex;
  align-items: center;
}

.nebula-utility-icons {
  display: flex;
  margin-right: 15px;
}

.nebula-icon-btn {
  position: relative;
  background: none;
  border: none;
  margin-left: 15px;
  font-size: 20px;
  color: #555;
  cursor: pointer;
}

.nebula-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #dc3545;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nebula-auth-buttons {
  display: flex;
}

.nebula-btn {
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  border: none;
  background: none;
}

.nebula-login-btn {
  color: #555;
}

.nebula-signup-btn {
  color: #333;
  font-weight: 500;
}

/* 메인 헤더 스타일 */
.nebula-main-header {
  background-color: white;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  position: relative;
}

.nebula-main-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nebula-main-header-content .success-icon {
  color: #B12E19;
}

.nebula-main-header-content .deadline-icon {
  color: #8B5CF6;
}

.nebula-main-header-content .wrap {
  width:260px;
  padding: 9px 0;
  border-radius: 8px;
  margin-right:15px;
  font-size: 14px;
  background-color: #F8FAFC;
  border: 1px solid #e2e8f0;
  position: relative;
  cursor: pointer;
}

/* 기본 요소 */
.nebula-main-header-content .default {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  gap: 6px;
}

.nebula-main-header-content .default i {
  font-size: 20px;
}

/* 호버시 뜰 요소 */
.nebula-main-header-content .hover-content {
  position: absolute;
  top: 13px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.2s;
  white-space: nowrap;
}

/* 호버 동작 */
.nebula-main-header-content .wrap:hover .default {
  opacity: 0;
}

.nebula-main-header-content .wrap:hover .hover-content {
  opacity: 1;
}

.nebula-main-logo {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.nebula-main-logo img {
  max-width: 230px;
  height: auto;
}

.nebula-main-logo-text {
  font-size: 26px;
  font-weight: 700;
  color: #b12e19;
  display: flex;
  align-items: center;
}

.nebula-main-logo-text i {
  margin-right: 10px;
  color: #b12e19;
}

.nebula-tagline {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

.nebula-header-wrapper .nebula-search-bar .nebula-search-btn {
  position: relative; /* 위치 조정을 위해 추가 */
  background-color: #b12e19;
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 16px;
  flex-shrink: 0;
  min-width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2; /* 다른 요소보다 앞에 표시 */
  right: 0; /* 오른쪽 끝에 붙임 */
  border-radius: 0 0px 0px 0; /* 오른쪽만 둥글게 */
}

.nebula-header-wrapper .nebula-search-bar {
  position: relative; /* 버튼 위치 조정을 위해 필요 */
  display: flex;
  align-items: center;
  width: 40%;
  border: 2px solid #b12e19;
  border-radius: 4px;
  /* overflow 속성 제거 */
}

.nebula-header-wrapper .nebula-search-input {
  width: 100%;
  padding: 10px 15px;
  border: none;
  outline: none;
  font-size: 14px;
  border-radius: 4px 0 0 4px; /* 왼쪽만 둥글게 */
}

.nebula-kakao-promo {
  display: flex;
  align-items: center;
  background-color: #FFEB3B;
  padding: 10px;
  border-radius: 6px;
}
/* 프로모션 슬라이드 스타일 수정 */
.nebula-promotion-slide {
  position: relative;
  width: 250px;
  height: 75px; /* 높이를 더 정확하게 설정 */
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.nebula-slide-container {
  display: flex;
  width: 400%;
  height: 100%;
  transition: all 0.5s ease; /* transform 대신 all로 변경 */
  will-change: transform; /* 성능 최적화 */
}

.nebula-slide-item {
  flex: 0 0 25%;
  width: 25%; /* 명시적으로 너비 지정 */
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  color: #333;
  box-sizing: border-box; /* 패딩이 너비에 포함되도록 설정 */
}

/* 각 슬라이드 아이템에 확실한 배경색 지정 */
/* 각 슬라이드 아이템 배경색 */
.nebula-slide-item.nebula-kakao-promo {
  background-color: #FFEB3B !important;
}

.nebula-slide-item.nebula-new-promo {
  background-color: #E3F2FD !important;
}

.nebula-slide-item.nebula-shipping-promo {
  background-color: #E8F5E9 !important;
}

.nebula-slide-item.nebula-discount-promo {
  background-color: #FFF3E0 !important;
}

/* 각 슬라이드 아이콘 스타일 명확히 지정 */
.nebula-kakao-icon i {
  font-size: 30px;
  color: #3b1e1e;
  background-color: #FEE500;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.nebula-promo-icon i {
  font-size: 30px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.nebula-slide-item.nebula-new-promo .nebula-promo-icon i {
  color: white;
  background-color: #2196F3;
}

.nebula-slide-item.nebula-shipping-promo .nebula-promo-icon i {
  color: white;
  background-color: #4CAF50;
}

.nebula-slide-item.nebula-discount-promo .nebula-promo-icon i {
  color: white;
  background-color: #FF9800;
}

/* 텍스트 스타일 명확히 지정 */
.nebula-kakao-text,
.nebula-promo-text {
  font-size: 12px;
  flex-grow: 1;
  overflow: hidden;
  color: #333; /* 확실한 텍스트 색상 지정 */
  padding-top: 10px; /* 상단 패딩 제거 */
  margin-top: -15px; /* 위로 5px 올림 */
  margin-left:10px
}

.nebula-kakao-title,
.nebula-promo-title {
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333; /* 확실한 텍스트 색상 지정 */
}

.nebula-kakao-subtitle,
.nebula-promo-subtitle {
  margin: 0;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;font-weight: bold;
}

/* 슬라이드 네비게이션 */
.nebula-slide-nav {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nebula-slide-btn {
  background: none;
  border: none;
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  cursor: pointer;
  padding: 0 5px;
}

.nebula-slide-indicators {
  display: flex;
  margin: 0 5px;
}

.nebula-slide-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  margin: 0 3px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nebula-slide-dot.active {
  background-color: rgba(0, 0, 0, 0.7);
}
.nebula-kakao-icon {
  margin-right: 10px;
  flex-shrink: 0;
}

.nebula-kakao-icon i {
  font-size: 30px;
  color: #3b1e1e;
  background-color: #FEE500;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.nebula-kakao-text {
  font-size: 12px;
  flex-grow: 1;
  overflow: hidden;
}

.nebula-kakao-title {
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nebula-kakao-subtitle {
  margin: 0;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 메인 네비게이션 스타일 */
.nebula-main-nav {
  background-color: white;
  /* padding: 10px 0; */
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  position: relative;
  z-index: 1500; /* 기존 50에서 1500으로 증가 */
}

.nebula-nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nebula-primary-nav {
  display: flex;
  flex-wrap: wrap;
}

.nebula-nav-item {
  display: flex;
  align-items: center;
  margin-right: 35px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  /* margin-bottom: 5px; */
  transition: transform 0.2s ease;
}

.nebula-nav-item:hover {
  transform: translateY(-2px);
}

.nebula-nav-item img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.nebula-nav-item i, .nebula-nav-icon {
  margin-right: 5px;
  font-size: 16px;
}

.nebula-secondary-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.nebula-secondary-nav-item {
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #666;
  text-decoration: none;
  font-size: 13px;
  border: 1px solid #CCCCCC;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 5px;
}

.nebula-secondary-nav-item img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.nebula-secondary-nav-item i {
  margin-right: 5px;
  font-size: 14px;
}

.nebula-more-menu {
  margin-left: 15px;
  font-size: 16px;
  color: #666;
  cursor: pointer;
}

/* 카테고리 드롭다운 메뉴 스타일 */
.nebula-category-dropdown {
  position: relative;
  padding: 10px 0;
}

.nebula-category-menu {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  width: 1200px;
  max-width: 100vw;
  max-height: 75vh;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 1600; /* 기존 1000에서 1600으로 증가 */
  border-radius: 4px;
  /* margin-top: 10px; */
}

.nebula-category-left {
  width: 220px;
  background-color: #f8f8f8;
  padding: 20px 0;
  border-right: 1px solid #eee;
  min-height: 400px;
  max-height: 70vh;
  overflow-y: auto;
  flex-shrink: 0;
}

.nebula-category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-category-item {
  padding: 0;
  height: 48px; /* 모든 카테고리 항목의 높이를 동일하게 설정 */
  display: block; /* 블록 레벨 요소로 변경 */
}

.nebula-category-link {
  display: flex;
  align-items: center;
  padding: 0 20px; /* 좌우 패딩만 설정 */
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s;
  height: 100%; /* 부모 높이에 맞춤 */
  width: 100%; /* 너비 100%로 설정하여 호버 영역 확장 */
}

/* 호버 영역 개선 */
.nebula-category-left .nebula-category-list {
  position: relative; /* 부모 요소에 relative 설정 */
}

.nebula-category-link:hover {
  background-color: #e9ecef;
}

.nebula-category-item.active .nebula-category-link {
  background-color: #e9ecef;
}

.nebula-category-dropdown .nebula-nav-item.active,
.nebula-category-dropdown .nebula-nav-item.active:hover {
  color: #b12e19;
  border-radius: 4px;
}

.nebula-category-dropdown .nebula-nav-item.active i,
.nebula-category-dropdown .nebula-nav-item.active:hover i {
  color: #b12e19;
}
.nebula-category-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.nebula-subcategory-right {
  flex: 1;
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.nebula-subcategory-banner {
  margin-bottom: 20px;
}

.nebula-subcategory-banner img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.nebula-subcategory-list {
  display: flex;
  flex-wrap: wrap;
}

.nebula-subcategory-group {
  width: 100%;
  padding: 0 10px 15px 0;
}

.nebula-subcategory-title {
  font-size: 14px;
  font-weight: 600;
  color: #b12e19;
  margin: 0 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

.nebula-subcategory-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-subcategory-items li {
  margin-bottom: 6px;
}

.nebula-subcategory-link {
  color: #666;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.2s;
}

.nebula-subcategory-link:hover {
  color: #b12e19;
  text-decoration: underline;
}

/* 모바일 메뉴 버튼 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999; /* 🔥 z-index 증가 */
}

/* 모바일 검색 버튼 */
.mobile-search-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999; /* 🔥 z-index 증가 */
}

/* 모바일 검색창 스타일 */
.mobile-search-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  padding: 10px 15px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 1000;
}

.mobile-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.mobile-search-input {
  width: 100%;
  padding: 10px 80px 10px 15px;
  border: 2px solid #b12e19;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.mobile-search-submit {
  position: absolute;
  right: 40px;
  background: none;
  border: none;
  font-size: 20px;
  color: #b12e19;
  cursor: pointer;
}

.mobile-search-close {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
}

/* 모바일 풀스크린 메뉴 */
.mobile-fullscreen-menu {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw; /* 🔥 뷰포트 전체 너비 */
  height: 100vh; /* 🔥 뷰포트 전체 높이 */
  background-color: white;
  z-index: 99999;
  overflow-y: auto;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateX(-100%); /* 🔥 왼쪽에서 슬라이드 */
  opacity: 0;
  box-sizing: border-box; /* 🔥 패딩 포함 */
}

.mobile-fullscreen-menu.active {
  display: block;
  transform: translateX(0); /* 🔥 중앙으로 이동 */
  opacity: 1;
}

/* 모바일 대분류/중분류 메뉴 스타일 */
.mobile-category-container {
  display: flex;
  height: calc(100vh - 80px); /* 🔥 헤더 높이만 제외 */
  border-top: 1px solid #eee;
  overflow: hidden; /*    스크롤 방지 */
}

/* 🔥 모바일 메뉴 스크롤 개선 */
.mobile-category-main,
.mobile-category-sub {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 🔥 iOS 스크롤 개선 */
}

.mobile-category-item {
  display: flex;
  align-items: center;
  padding: 15px;
  color: #333;
  position: relative;
  border-bottom: 1px solid #f1f1f1;
}

.mobile-category-item.active {
  background-color: white;
  color: #b12e19;
  border-left: 3px solid #b12e19;
}

.mobile-category-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.mobile-category-item i {
  position: absolute;
  right: 15px;
  font-size: 12px;
}

.mobile-category-sub {
  width: 60%;
  padding: 15px;
  overflow-y: auto;
}

.mobile-subcategory-group {
  margin-bottom: 20px;
}

.mobile-subcategory-title {
  font-size: 16px;
  font-weight: 600;
  color: #b12e19;
  margin: 0 0 10px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.mobile-subcategory-items {
  display: flex;
  flex-wrap: wrap;
}

.mobile-subcategory-link {
  width: 50%;
  padding: 8px 0;
  color: #333;
  text-decoration: none;
  font-size: 14px;
}

.mobile-subcategory-link:hover {
  color: #b12e19;
}

.mobile-menu-common-links {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 15px;
  background-color: #f8f8f8;
  border-top: 1px solid #eee;
}

.mobile-menu-common-link {
  display: flex;
  align-items: center;
  width: 33.33%;
  padding: 10px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  text-align: center;
  justify-content: center;
}

.mobile-menu-common-link img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

/* 모바일 메뉴 헤더 */
.mobile-menu-header {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 15px;
  border-bottom: 1px solid #eee;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.mobile-menu-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.mobile-menu-close:hover {
  background-color: #f0f0f0;
}
/* 모바일 공통 클래스 */
.mobile-hidden {
  display: none !important;
}

/* 반응형 스타일 */
@media (max-width: 1200px) {
  .nebula-main-header-content {
    flex-wrap: wrap;
  }

  .nebula-main-logo {
    order: 1;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .nebula-search-bar {
    order: 2;
    width: 60%;
    margin-bottom: 15px;
  }

  .nebula-kakao-promo {
    order: 3;
    width: 35%;
  }

  .nebula-category-menu {
    width: 90vw;
    max-width: 1000px;
  }
}

@media (max-width: 992px) {
  .nebula-category-menu {
    width: 90vw;
    max-width: 700px;
  }

  .nebula-subcategory-group {
    width: 50%;
  }

  .nebula-search-bar {
    width: 70%;
  }

  .nebula-kakao-promo {
    width: 25%;
  }
}

@media (max-width: 768px) {
  /* 모바일 메뉴 및 검색 버튼 표시 */
  .mobile-menu-btn,
  .mobile-search-btn {
    display: block;
  }

  /* 헤더 레이아웃 조정 */
  .nebula-main-header {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .nebula-main-header-content {
    justify-content: center;
    padding: 0 50px; /* 좌우 버튼 공간 확보 */
  }

  .nebula-main-logo {
    order: 1;
    margin: 0;
    width: auto;
  }

  /* 🔥 모바일 로고 크기 증가 */
  .nebula-main-logo img {
    max-width: 280px; /* 230px에서 280px로 증가 */
    max-height: 50px; /* 40px에서 50px로 증가 */
  }

  /* 헤더 내 요소 조정 */
  .nebula-header-content {
    justify-content: flex-end;
  }
}

@media (max-width: 576px) {
  /* 로고 크기 조정 */
  .nebula-main-logo img {
    max-width: 260px; /* 280px에서 260px로 조정 */
    max-height: 45px; /* 50px에서 45px로 조정 */
  }

  /* 모바일 메뉴 조정 */
  .mobile-category-container {
    flex-direction: column;
  }

  .mobile-category-main {
    width: 100%;
    height: auto;
    max-height: 40vh;
    border-right: none;
    border-bottom: 1px solid #eee;
  }

  .mobile-category-sub {
    width: 100%;
    height: auto;
    max-height: calc(60vh - 150px);
  }

  .mobile-subcategory-link {
    width: 100%;
  }

  /* 검색창 조정 */
  .mobile-search-input {
    padding: 8px 70px 8px 10px;
    font-size: 13px;
  }

  /* 모바일 메뉴 공통 링크 조정 */
  .mobile-menu-common-link {
    font-size: 12px;
  }

  .mobile-menu-common-link img {
    width: 16px;
    height: 16px;
  }
}

/*    아주 작은 화면에서 로고 크기 최적화 */
@media (max-width: 480px) {
  .nebula-main-logo img {
    max-width: 250px; /* 260px에서 240px로 조정 */
    max-height: 52px; /* 45px에서 42px로 조정 */
  }
}

/*    매우 작은 화면에서 로고 크기 최적화 */
@media (max-width: 360px) {
  .nebula-main-logo img {
    max-width: 220px; /* 240px에서 220px로 조정 */
    max-height: 40px; /* 42px에서 40px로 조정 */
  }
}
/* 로그인/로그아웃 버튼 스타일 */
.auth-buttons {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.user-name {
  color: #333333;
  font-size: 14px;
  margin-right: 10px;
}

.logout-btn, .login-btn, .signup-btn {
  padding: 6px 12px;
  font-size: 13px;
  color: #333333;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  margin-left: 5px;
}

.logout-btn:hover, .login-btn:hover, .signup-btn:hover {
  text-decoration: underline;
}

/* 🔥 카테고리 그리드 레이아웃 - 강력한 가로 나열 */
.nebula-category-grid {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  gap: 15px !important;
  padding: 10px 0;
  align-items: flex-start !important;
}

/* 🔥 3차 카테고리 섹션 - 강제 가로 배치 */
.nebula-third-category-section {
  flex: 0 0 calc(32% - 2.5px) !important;
  width: calc(32% - 2.5px) !important;
  max-width: calc(32% - 2.5px) !important;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 15px;
  background-color: #fafafa;
  transition: box-shadow 0.2s ease;
  box-sizing: border-box !important;
  margin-bottom: 15px;
}

.nebula-third-category-section:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 🔥 3차 카테고리 헤더 */
.nebula-third-category-header {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #b12e19;
}

.nebula-third-category-link {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #b12e19;
  text-decoration: none;
  transition: color 0.2s ease;
}

.nebula-third-category-link:hover {
  /* color: #2c5aa0; */
}

.nebula-third-category-link i {
  margin-right: 8px;
  font-size: 14px;
}

/* 🔥 4차 카테고리 가로 그리드 */
.nebula-fourth-category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
  margin-top: 10px;
}

/* 🔥 4차 카테고리 아이템 */
.nebula-fourth-category-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  color: #666;
  text-decoration: none;
  font-size: 13px;
  transition: all 0.2s ease;
  min-height: 36px;
  box-sizing: border-box;
}

.nebula-fourth-category-item:hover {
  /* background-color: #e3f2fd; */
  border-color: #b12e19;
  color: #b12e19;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px #eee;
}

.nebula-fourth-category-icon {
  margin-right: 6px;
  color: #b12e19;
  font-weight: bold;
}

/* 🔥 2차 카테고리만 있는 경우 */
.nebula-second-only-section {
  padding: 10px 0;
}

.nebula-second-only-link {
  display: inline-flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  color: #495057;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.nebula-second-only-link:hover {
  background-color: #e3f2fd;
  border-color: #b12e19;
  color: #b12e19;
}

.nebula-second-only-link i {
  margin-right: 8px;
}

/* 🔥 반응형 처리 */
@media (max-width: 768px) {
  .nebula-fourth-category-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 6px;
  }

  .nebula-fourth-category-item {
    padding: 6px 8px;
    font-size: 12px;
    min-height: 32px;
  }

  .nebula-third-category-link {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .nebula-fourth-category-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .nebula-category-grid {
    gap: 15px;
  }

  .nebula-third-category-section {
    padding: 12px;
  }
}

/* 🔥 모바일 로딩 스켈레톤 */
.mobile-category-loading {
  padding: 15px;
}

.mobile-category-skeleton {
  height: 55px;
  background-color: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 10px;
  animation: pulse 1.5s infinite;
}

/* 🔥 모바일 카테고리 아이템 터치 개선 */
.mobile-category-item {
  min-height: 55px !important;
  display: flex !important;
  align-items: center;
  padding: 15px !important;
  color: #333;
  position: relative;
  border-bottom: 1px solid #f1f1f1;
  transition: all 0.2s ease;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(74, 108, 247, 0.2);
}

.mobile-category-item:active {
  background-color: #e3f2fd;
  transform: scale(0.98);
}

.mobile-category-item.active {
  background-color: white !important;
  color: #b12e19 !important;
  border-left: 4px solid #b12e19 !important;
  font-weight: 600;
}

/* 🔥 모바일 서브카테고리 그룹 개선 */
.mobile-subcategory-group {
  margin-bottom: 25px !important;
}

.mobile-subcategory-title {
  font-size: 16px !important;
  font-weight: 600;
  color: #b12e19;
  margin: 0 0 15px 0 !important;
  padding: 10px 15px 8px 15px !important;
  border-bottom: 2px solid #b12e19 !important;
  background-color: #f8f9fa;
  border-radius: 6px 6px 0 0;
}

/* 🔥 모바일 서브카테고리 아이템 컨테이너 */
.mobile-subcategory-items {
  display: block !important;
  background-color: white;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* 🔥 모바일 카테고리별 스타일 */
.mobile-second-category,
.mobile-third-category,
.mobile-fourth-category {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-second-category:last-child,
.mobile-third-category:last-child,
.mobile-fourth-category:last-child {
  border-bottom: none;
}

/* 🔥 모바일 링크 스타일 */
.mobile-subcategory-link {
  width: 100% !important;
  padding: 12px 15px !important;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  display: flex !important;
  align-items: center;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: rgba(74, 108, 247, 0.2);
}

.mobile-subcategory-link:hover,
.mobile-subcategory-link:active {
  color: #b12e19 !important;
  background-color: #f8f9fa !important;
}

/* 🔥 2차 카테고리 링크 */
.mobile-second-link {
  font-weight: 600 !important;
  color: #2c5aa0 !important;
  background-color: #f8f9fa !important;
}

.mobile-second-link i {
  margin-right: 8px;
  color: #b12e19;
}

/* 🔥 3차 카테고리 링크 */
.mobile-third-link {
  font-weight: 500 !important;
  padding-left: 25px !important;
  color: #495057 !important;
}

.mobile-third-link i {
  margin-right: 8px;
  color: #6c757d;
  font-size: 12px;
}

/* 🔥 4차 카테고리 링크 */
.mobile-fourth-link {
  padding-left: 40px !important;
  color: #6c757d !important;
  font-size: 13px !important;
}

.mobile-fourth-indent {
  margin-right: 8px;
  color: #adb5bd;
  font-size: 12px;
  width: 12px;
}

/* 🔥 모바일 서브카테고리 영역 개선 */
.mobile-category-sub {
  width: 60% !important;
  padding: 15px !important;
  overflow-y: auto;
  background-color: #fafafa;
}

/* 🔥 모바일 메뉴 안정성 개선 */
.mobile-fullscreen-menu.active {
  display: block !important;
  transform: translateY(0) !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* 🔥 모바일 반응형 개선 */
@media (max-width: 576px) {
  .mobile-category-container {
    flex-direction: column !important;
  }

  .mobile-category-main {
    width: 100% !important;
    height: auto !important;
    max-height: 35vh !important;
    border-right: none !important;
    border-bottom: 1px solid #eee;
  }

  .mobile-category-sub {
    width: 100% !important;
    height: auto !important;
    max-height: calc(65vh - 120px) !important;
  }

  .mobile-subcategory-link {
    font-size: 13px !important;
    padding: 10px 15px !important;
  }

  .mobile-third-link {
    padding-left: 20px !important;
  }

  .mobile-fourth-link {
    padding-left: 30px !important;
  }
}

/* 🔥 모바일 아코디언 메뉴 스타일 */
.mobile-accordion-menu {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

.mobile-category-accordion {
  width: 100%;
}

/* 🔥 1차 카테고리 스타일 */
.mobile-category-level-1 {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-category-header-1 {
  display: flex !important;
  align-items: center;
  padding: 15px 20px !important;
  background-color: #f8f9fa;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 4px solid transparent;
}

.mobile-category-header-1:active {
  background-color: #e9ecef;
  transform: scale(0.98);
}

.mobile-category-header-1.active {
  background-color: #e3f2fd !important;
  color: #b12e19 !important;
  border-left-color: #b12e19 !important;
  font-weight: 600;
}

.mobile-category-icon {
  width: 24px !important;
  height: 24px !important;
  margin-right: 12px !important;
}

.mobile-category-name {
  flex: 1;
  font-size: 16px;
  font-weight: 500;
}

.mobile-category-header-1 i {
  font-size: 14px;
  transition: transform 0.2s ease;
}

/* 🔥 1차 카테고리 내용 */
.mobile-category-content-1 {
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
}

/* 🔥 2차 카테고리 스타일 */
.mobile-category-level-2 {
  border-bottom: 1px solid #f8f9fa;
}

.mobile-category-header-2 {
  display: flex !important;
  align-items: center;
  padding: 12px 25px !important;
  background-color: #ffffff;
  position: relative;
}

.mobile-subcategory-link-header {
  flex: 1;
  display: flex !important;
  align-items: center;
  color: #495057 !important;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  padding: 0 !important;
}

.mobile-subcategory-link-header:hover {
  color: #b12e19 !important;
}

.mobile-subcategory-link-header i {
  margin-right: 8px;
  color: #6c757d;
  font-size: 14px;
}

.mobile-accordion-toggle {
  background: none;
  border: none;
  color: #6c757d;
  font-size: 16px;
  cursor: pointer;
  padding: 5px;
  transition: color 0.2s ease;
  margin-left: 10px;
}

.mobile-accordion-toggle:hover {
  color: #b12e19;
}

/* 🔥 2차 카테고리 내용 (3차/4차) */
.mobile-category-content-2 {
  background-color: #fafafa;
  padding: 0;
  overflow: hidden;
}

/* 🔥 아코디언 애니메이션 */
.mobile-accordion-enter-active,
.mobile-accordion-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
}

.mobile-accordion-enter-from,
.mobile-accordion-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

/* 🔥 3차/4차 카테고리 스타일 개선 */
.mobile-third-category,
.mobile-fourth-category,
.mobile-second-category {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-third-category:last-child,
.mobile-fourth-category:last-child,
.mobile-second-category:last-child {
  border-bottom: none;
}

/* 🔥 모바일 링크 스타일 개선 */
.mobile-subcategory-link {
  width: 100% !important;
  padding: 10px 30px !important;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  display: flex !important;
  align-items: center;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: rgba(74, 108, 247, 0.2);
}

.mobile-subcategory-link:hover,
.mobile-subcategory-link:active {
  color: #b12e19 !important;
  background-color: #f8f9fa !important;
}

/* 🔥 3차 카테고리 링크 */
.mobile-third-link {
  font-weight: 500 !important;
  padding-left: 35px !important;
  color: #495057 !important;
  background-color: rgba(74, 108, 247, 0.02) !important;
}

.mobile-third-link i {
  margin-right: 8px;
  color: #b12e19;
  font-size: 12px;
}

/* 🔥 4차 카테고리 링크 */
.mobile-fourth-link {
  padding-left: 50px !important;
  color: #6c757d !important;
  font-size: 13px !important;
  background-color: rgba(74, 108, 247, 0.01) !important;
}

.mobile-fourth-indent {
  margin-right: 8px;
  color: #adb5bd;
  font-size: 12px;
  width: 12px;
}

/* 🔥 2차 카테고리만 있는 경우 */
.mobile-second-link {
  font-weight: 600 !important;
  color: #2c5aa0 !important;
  background-color: rgba(74, 108, 247, 0.05) !important;
  padding-left: 35px !important;
}

.mobile-second-link i {
  margin-right: 8px;
  color: #b12e19;
}

/* 🔥 모바일 반응형 개선 */
@media (max-width: 576px) {
  .mobile-category-header-1 {
    padding: 12px 15px !important;
  }

  .mobile-category-header-2 {
    padding: 10px 20px !important;
  }

  .mobile-subcategory-link {
    padding: 8px 25px !important;
    font-size: 13px !important;
  }

  .mobile-third-link {
    padding-left: 30px !important;
  }

  .mobile-fourth-link {
    padding-left: 40px !important;
  }

  .mobile-second-link {
    padding-left: 30px !important;
  }
}

/* 🔥 터치 반응성 개선 */
@media (hover: none) and (pointer: coarse) {
  .mobile-category-header-1:active,
  .mobile-category-header-2:active,
  .mobile-subcategory-link:active {
    background-color: #e3f2fd !important;
    transform: none;
  }
}
</style>